export const AppRoutes = {
  '403': '/403',
  '404': '/404',
  wc: '/wc',
  terms: '/terms',
  swap: '/swap',
  stake: '/stake',
  privacy: '/privacy',
  licenses: '/licenses',
  index: '/',
  imprint: '/imprint',
  home: '/home',
  earn: '/earn',
  cookie: '/cookie',
  bridge: '/bridge',
  addressBook: '/address-book',
  hypernative: {
    oauthCallback: '/hypernative/oauth-callback',
  },
  addOwner: '/addOwner',
  _offline: '/_offline',
  apps: {
    open: '/apps/open',
    index: '/apps',
    custom: '/apps/custom',
    bookmarked: '/apps/bookmarked',
  },
  balances: {
    positions: '/balances/positions',
    nfts: '/balances/nfts',
    index: '/balances',
  },
  newSafe: {
    load: '/new-safe/load',
    create: '/new-safe/create',
    advancedCreate: '/new-safe/advanced-create',
  },
  settings: {
    setup: '/settings/setup',
    security: '/settings/security',
    notifications: '/settings/notifications',
    modules: '/settings/modules',
    index: '/settings',
    environmentVariables: '/settings/environment-variables',
    data: '/settings/data',
    cookies: '/settings/cookies',
    appearance: '/settings/appearance',
    safeApps: {
      index: '/settings/safe-apps',
    },
  },
  share: {
    safeApp: '/share/safe-app',
  },
  spaces: {
    settings: '/spaces/settings',
    settingsGeneral: '/spaces/settings/general',
    settingsAccount: '/spaces/settings/account',
    settingsAbout: '/spaces/settings/about',
    safeAccounts: '/spaces/safe-accounts',
    members: '/spaces/members',
    plans: '/spaces/plans',
    index: '/spaces',
    addressBook: '/spaces/address-book',
    createSpace: '/spaces/create-space',
    transactions: '/spaces/transactions',
    security: '/spaces/security',
    activity: '/spaces/activity',
  },
  transactions: {
    tx: '/transactions/tx',
    queue: '/transactions/queue',
    msg: '/transactions/msg',
    messages: '/transactions/messages',
    index: '/transactions',
    history: '/transactions/history',
  },
  welcome: {
    spaces: '/welcome/spaces',
    index: '/welcome',
    accounts: '/welcome/accounts',

    // Onboarding routes
    createSpace: '/welcome/create-space',
    selectSafes: '/welcome/select-safes',
    inviteMembers: '/welcome/invite-members',
    survey: '/welcome/survey',
  },
}

export const UNDEPLOYED_SAFE_BLOCKED_ROUTES = [
  AppRoutes.bridge,
  AppRoutes.swap,
  AppRoutes.stake,
  AppRoutes.earn,
  ...Object.values(AppRoutes.apps),
]
